import React from 'react'
import { styled } from '@mui/material/styles'
import palette from 'core-system/Themes/palette'
import { Button, ButtonProps, CircularProgress } from '@mui/material'

const PrimaryButtonContainer = styled(Button)(() => ({
  backgroundColor: palette.primary.pink100,
  borderRadius: '0.375rem',
  padding: '0.625rem 1rem',
  fontFamily: 'PolySans',
  textTransform: 'none',
  fontSize: '0.875rem',
  border: `1px solid ${palette.primary.pink800}`,
  color: palette.primary.pink800,

  '&:hover': {
    backgroundColor: palette.white,
    border: `1px solid black`,
    color: 'black',
  },
}))

interface PrimaryButtonProps extends ButtonProps {
  children: React.ReactNode
  isLoading?: boolean
}

const PrimaryButton = React.memo((props: PrimaryButtonProps) => {
  const { children, isLoading, ...rest } = props

  if (isLoading) {
    return (
      <PrimaryButtonContainer {...rest} variant='outlined' color='secondary'>
        <CircularProgress size={20} color='inherit' />
      </PrimaryButtonContainer>
    )
  }

  return (
    <PrimaryButtonContainer {...rest} variant='outlined' color='secondary'>
      {children}
    </PrimaryButtonContainer>
  )
})

export default PrimaryButton
